import { ReactComponent as SvgChevron } from '@img/icons/chevron-right.svg';
import { ReactComponent as SvgClose } from '@img/icons/close.svg';
import Button from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import S from './FilterMobile.styles';
import xor from 'lodash/xor';
const FilterMobile = ({ dropdown, items, showReset = true, title, translations, value, onChange, onReset, }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [activeFilters, setActiveFilters] = React.useState([]);
    React.useEffect(() => {
        if (isOpen) {
            setActiveFilters([]);
        }
    }, [isOpen]);
    return (React.createElement(S.Container, { initial: "closed", animate: isOpen ? 'opened' : 'closed' },
        React.createElement(S.Title, null, title),
        React.createElement(S.ButtonWrapper, null,
            React.createElement(Button, { branding: "primaryAlt", title: translations && translations['customerportal.technical-library.filterbtntext']
                    ? translations['customerportal.technical-library.filterbtntext']
                    : 'Filter', onClick: (event) => {
                    event.preventDefault();
                    setIsOpen(!isOpen);
                } })),
        React.createElement(S.SelectedFilters, null, items
            ? items.map((item) => (React.createElement(React.Fragment, null, item.options.map((option) => {
                const selectedOptions = value[item.name] ?? [];
                return (React.createElement(React.Fragment, null, selectedOptions.includes(option.value) && (React.createElement(S.SelectedFilterBtn, { type: "button", key: option.value, onClick: () => onChange(item.name, option.value) },
                    option.text,
                    " ",
                    React.createElement(SvgClose, null)))));
            }))))
            : null),
        React.createElement(S.Overlay, { variants: {
                closed: {
                    x: 0,
                },
                opened: {
                    x: '-100%',
                },
            }, transition: {
                duration: 0.3,
                ease: 'easeOut',
            } },
            React.createElement(React.Fragment, null,
                React.createElement(S.FilterTop, null,
                    React.createElement(S.FilterTitle, null, title),
                    React.createElement(S.CloseBtn, { onClick: (event) => {
                            event.preventDefault();
                            setActiveFilters([]);
                            setIsOpen(false);
                        } },
                        React.createElement(S.CloseIcon, null))),
                React.createElement(S.ItemList, null,
                    dropdown && (React.createElement(S.Item, { key: dropdown.name, onClick: (event) => {
                            event.preventDefault();
                            setActiveFilters(xor([...activeFilters], [dropdown.name]));
                        } },
                        React.createElement(S.ItemText, null, dropdown.title),
                        React.createElement(S.Arrow, null,
                            React.createElement("span", null, SvgChevron)))),
                    items
                        ? items.map((item) => (React.createElement(S.Item, { key: item.name, initial: "closed", animate: activeFilters.includes(item.name) ? 'opened' : 'closed', "aria-expanded": activeFilters.includes(item.name) },
                            React.createElement(S.ItemTitle, { onClick: (event) => {
                                    event.preventDefault();
                                    setActiveFilters(xor([...activeFilters], [item.name]));
                                } },
                                React.createElement("span", null, item.title),
                                React.createElement(S.ItemArrow, null,
                                    React.createElement(S.ItemIcon, null))),
                            !!item.options.length && (React.createElement(S.OptionOverlay, { variants: {
                                    closed: {
                                        opacity: 0,
                                        transitionEnd: {
                                            display: 'none',
                                        },
                                    },
                                    opened: {
                                        display: 'block',
                                        opacity: 1,
                                    },
                                }, transition: {
                                    duration: 0.15,
                                    ease: 'easeOut',
                                } },
                                React.createElement(S.OptionList, null, item.options.map((option) => {
                                    const id = `${item.name}-${option.value}`;
                                    const selectedOptions = value[item.name] ?? [];
                                    return (React.createElement(S.Option, { key: option.value },
                                        React.createElement(S.OptionInput, { id: id, checked: selectedOptions.includes(option.value), name: item.name, type: "checkbox", value: option.value, onChange: () => {
                                                onChange(item.name, option.value);
                                            } }),
                                        React.createElement(S.OptionLabel, { htmlFor: id }, option.text)));
                                })))))))
                        : null),
                React.createElement(S.FilterMid, null,
                    React.createElement(Button, { branding: "black", title: translations && translations['customerportal.technical-library.applybtntext']
                            ? translations['customerportal.technical-library.applybtntext']
                            : 'Apply filters', onClick: (event) => {
                            event.preventDefault();
                            setActiveFilters([]);
                            setIsOpen(false);
                        } }),
                    showReset && (React.createElement(Button, { branding: "white", title: translations && translations['customerportal.technical-library.clearbtntext']
                            ? translations['customerportal.technical-library.clearbtntext']
                            : 'Clear All', onClick: (event) => {
                            event.preventDefault();
                            setActiveFilters([]);
                            onReset && onReset();
                        } })))),
            React.createElement(S.SubmitWrapper, null))));
};
export default FilterMobile;
